import React from 'react';
import { resolveBankType } from '../../../../utils/bankAccountInvoiceUtils';

/**
 * Bootstrap-модалка реквізитів для рахунку на оплату (#invoiceRequisitesModal).
 */
const InvoiceRequisitesModal = ({
  account,
  recipientName,
  edrpou,
  invoiceIban,
  bankName,
  onRecipientNameChange,
  onEdrpouChange,
  onInvoiceIbanChange,
  onBankNameChange,
  onClose,
  onSubmit,
  saving = false,
  error = '',
  onClearError,
}) => {
  const bankType = account ? resolveBankType(account) : null;

  return (
    <div
      className="modal fade"
      id="invoiceRequisitesModal"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="invoiceRequisitesModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-md modal-dialog-centered" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title font-weight-bold" id="invoiceRequisitesModalLabel">
              Реквізити для рахунку на оплату
            </h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              onClick={onClose}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            {account && (
              <p className="text-muted mb-3">
                Рахунок: <strong>{account.name}</strong>
                <br />
                <span style={{ fontSize: '0.85rem' }}>
                  Можна зберегти частково. Для виставлення рахунку потрібні всі чотири поля.
                </span>
              </p>
            )}
            <form>
              <div className="form-group">
                <label htmlFor="invoiceReqRecipient">Отримувач</label>
                <input
                  id="invoiceReqRecipient"
                  type="text"
                  className="form-control"
                  value={recipientName}
                  onChange={(e) => onRecipientNameChange(e.target.value)}
                  placeholder="Наприклад: ФОП Тимчук О. Л."
                />
              </div>
              <div className="form-group">
                <label htmlFor="invoiceReqEdrpou">ЄДРПОУ</label>
                <input
                  id="invoiceReqEdrpou"
                  type="text"
                  className="form-control"
                  value={edrpou}
                  onChange={(e) => onEdrpouChange(e.target.value.replace(/\s/g, ''))}
                  placeholder="Код ЄДРПОУ"
                />
              </div>
              <div className="form-group">
                <label htmlFor="invoiceReqIban">IBAN</label>
                <input
                  id="invoiceReqIban"
                  type="text"
                  className="form-control"
                  value={invoiceIban}
                  onChange={(e) => onInvoiceIbanChange(e.target.value.replace(/\s/g, ''))}
                  placeholder="UA…"
                />
                {bankType === 'PRIVATBANK' && (
                  <small className="form-text text-muted">
                    За замовчуванням підставляється IBAN з інтеграції ПриватБанку.
                  </small>
                )}
                {bankType === 'MONOBANK' && (
                  <small className="form-text text-muted">
                    Для Монобанку вкажіть IBAN вручну (ID рахунку API — не IBAN).
                  </small>
                )}
              </div>
              <div className="form-group mb-0">
                <label htmlFor="invoiceReqBankName">Назва банку</label>
                <input
                  id="invoiceReqBankName"
                  type="text"
                  className="form-control"
                  value={bankName}
                  onChange={(e) => onBankNameChange(e.target.value)}
                  placeholder={'Наприклад: ПАТ "ПРИВАТБАНК", м.Київ'}
                />
              </div>
            </form>

            {error && (
              <div className="alert alert-danger alert-dismissible fade show mt-3 mb-0" role="alert">
                {error}
                <button type="button" className="close" onClick={onClearError} aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
            )}
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              data-dismiss="modal"
              onClick={onClose}
              disabled={saving}
            >
              Закрити
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={onSubmit}
              disabled={saving}
            >
              {saving ? 'Збереження…' : 'Зберегти'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InvoiceRequisitesModal;
